import { lazy } from 'react';
const Invitation = lazy(() => import('@/pages/Invitation'));

const routes: any = [{ path: '/invitation', component: Invitation }];

export default [...routes];
